export enum ConfidenceLevels {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  UNMAPPED = 'unmapped',
  UNPROCESSED = 'unprocessed'
}
